export default {
    data() {
        return {
            routeName: null,
            search: {},
            list: {},
            resp: null,
            paginator: {},
            order_by: {},
            is_filter_show: false
        }
    },
    watch: {
        '$route.query': function () {
            var vm = this;

            vm.load();
        },
    },
    computed: {
        hasActiveFilter() {
            if (!this.$route.query) return false

            const ignoredKeys = ['is_deleted', 'page'];

            return Object.keys(this.$route.query)
                .filter(key => !ignoredKeys.includes(key))
                .some(key => {
                    const value = this.$route.query[key];
                    return value !== null && value !== undefined && value !== '';
                });
        }
    },
    created() {
        if (this.$route)
            this.order_by = this.$route.query.order_by;

        this.load();
    },
    methods: {
        async _search() {
            return {};
        },

        _getList(resp) {
            return resp.data.data;
        },

        async _delete() {
            return {};
        },

        _beforeSearch() { },

        load() {
            if (!this.$route) return;

            this.search = { ...this.$route.query };

            this.$orderBy.reset(this.search);

            this._doSearch();
        },

        sortBy(columnName) {
            this.$orderBy.setColumn(columnName);

            const query = this.$orderBy.toQuery();

            if (query) {
                this.search.order_by = query.order_by;
                this.search.sort_by = query.sort_by;
            }

            this.doSearch();
        },

        doSearch() {
            const query = this.$orderBy.toQuery();

            if (query) {
                this.search.order_by = query.order_by;
                this.search.sort_by = query.sort_by;
            } else {
                delete this.search.order_by;
                delete this.search.sort_by;
            }

            this.$router.replace({
                name: this.routeName,
                query: this.search
            });
        },

        async _doSearch() {
            var vm = this;

            const search = { ...this.search };
            this._beforeSearch(search);

            try {
                vm.$loading.on([vm.routeName, 'list'].join('_'));

                var resp = await this._search(search);
                var data = null;

                data = resp.data;

                this.list = this._getList(resp);

                this.paginator = data.meta;

                vm.autoRedirect();
            } catch (error) {
                vm.$flash.error(error.response.data.message);
            }

            vm.$loading.off([vm.routeName, 'list'].join('_'));
        },

        async destroy(id, is_permanent = 0) {
            var vm = this;

            vm.$alert.confirm(vm.$t('basic.alert.delete'), async function (result) {
                if (result.isConfirmed) {
                    var params = {
                        id: id,
                        is_permanent: is_permanent
                    };

                    try {
                        vm.$loading.on([vm.routeName, 'delete', id].join('_'));

                        var resp = await vm._delete(params);

                        vm._doSearch();

                        vm.$flash.success(resp.data.message);
                    } catch (error) {
                        vm.$flash.error(error.response.data.message);
                    }

                    vm.$loading.off([vm.routeName, 'delete', id].join('_'));
                }
            });
        },

        autoRedirect() {
            var currPage = this.paginator.current_page;
            var lastPage = this.paginator.last_page;

            if (parseInt(currPage) > parseInt(lastPage)) {
                this.search.page = lastPage;
                this.doSearch();
            }
        },

        clear() {
            const currentIsDeleted = this.search.is_deleted;

            // reset semua search
            this.search = {};

            // kembalikan is_deleted jika ada
            if (currentIsDeleted !== undefined && currentIsDeleted !== null) {
                this.search.is_deleted = currentIsDeleted;
            }

            // reset sorting
            this.$orderBy.reset(null);

            this.doSearch();
        },

        goto(page) {
            this.search.page = page;
            this.doSearch();
        },

        setTrash(deleted) {
            var vm = this;

            vm.search.deleted = deleted;
            vm.doSearch();
        },

        async restore(id) {
            var vm = this;

            vm.$alert.confirm(vm.$t('basic.alert.restore'), async function (result) {
                if (result.isConfirmed) {

                    try {
                        vm.$loading.on([vm.routeName, 'restore', id].join('_'));
                        var resp = await vm._restore(id);
                        vm._doSearch();

                        vm.$flash.success(resp.data.message);
                    } catch (error) {
                        vm.$flash.error(error.response.data.message);
                    }

                    vm.$loading.off([vm.routeName, 'restore', id].join('_'));

                }
            });
        },
        onSubmitFilter(data) {
            var vm = this;

            if (vm.search.keyword)
                data.keyword = vm.search.keyword;

            if (vm.search.is_deleted)
                data.is_deleted = vm.search.is_deleted;

            vm.search = data;
            vm.doSearch();
        }
    }
};
